import script from "./HistoryList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryList.vue?vue&type=script&setup=true&lang=ts"

import "./HistoryList.vue?vue&type=style&index=0&id=191d3817&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-191d3817"]])

export default __exports__